import { styled } from "goober";

const Element = styled("div")`
  display: flex;
  flex-direction: column;
`;

type Props = {
  children?: React.ReactNode;
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
  vertical?: number;
  horizontal?: number;
  center?: boolean;
  gap?: number;
};

export function Box({
  children,
  top,
  bottom,
  left,
  right,
  horizontal,
  vertical,
  center,
  gap,
}: Props) {
  return (
    <Element
      style={{
        paddingLeft: horizontal ?? left,
        paddingRight: horizontal ?? right,
        paddingTop: vertical ?? top,
        paddingBottom: vertical ?? bottom,
        alignItems: center ? "center" : undefined,
        justifyContent: center ? "center" : undefined,
        gap: gap ?? 0,
      }}
    >
      {children}
    </Element>
  );
}
